import {Dispatch, SetStateAction} from 'react';
import {SearchRequest} from '../interfaces';
import {useLocalStorage} from '@frontend/shared';

const SEARCH_HISTORY_KEY = 'at.ug.search-history';

export function useSearchHistory(): [SearchRequest[], Dispatch<SetStateAction<SearchRequest[]>>] {
    const [searchHistory, setSearchHistory] = useLocalStorage<SearchRequest[]>(
        SEARCH_HISTORY_KEY,
        []
    );

    return [searchHistory, setSearchHistory];
}
